var React = require('react');

function FlagPl (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"7.5","height":"5","fill":"#dc143c","key":0}),React.createElement("rect",{"width":"7.5","height":"2.5","fill":"#fff","key":1})]);
}

FlagPl.defaultProps = {"viewBox":"0 0 7.5 5"};

module.exports = FlagPl;

FlagPl.default = FlagPl;
